export default __webpack_public_path__ + "static/media/defu.10691648.png";